import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import {
  GetPendingServicesResponse,
  PaginatedRequest,
  PaginatedResponse,
  PendingService,
  ZonedDate,
} from 'src/app/models/pending-services/pending-services.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PendingServicesService {
  apiUrl = environment.url;
  //apiUrl: string = 'http://localhost:3000';

  constructor(private readonly http: HttpClient) {}

  getAllPendingServices(params: {
    fromDate: string;
    toDate: string;
    clientGuid?: string | null;
    serviceFilter?: string | null;
    zonesGuid?: string[]; 
    productsName?: string[]; 
  }): Observable<PendingService[]> {
    let httpParams = new HttpParams()
      .set('fromDate', params.fromDate)
      .set('toDate', params.toDate);

    if (params.clientGuid) {
      httpParams = httpParams.set('clientGuid', params.clientGuid);
    }
    if (params.serviceFilter) {
      httpParams = httpParams.set('serviceFilter', params.serviceFilter);
    }

    if (Array.isArray(params.zonesGuid) && params.zonesGuid.length > 0) {
      for (const z of params.zonesGuid) {
        httpParams = httpParams.append('zonesGuid', z);
      }
    }
    if (Array.isArray(params.productsName) && params.productsName.length > 0) {
      for (const p of params.productsName) {
        httpParams = httpParams.append('productsName', p);
      }
    }

    return this.http.get<PendingService[]>(`${this.apiUrl}/pending-services`, {
      params: httpParams,
    });
  }

  getPaginatedPendingServices(
    requestBody: PaginatedRequest
  ): Observable<PaginatedResponse> {
    return this.http.post<PaginatedResponse>(
      `${this.apiUrl}/pending-services/paginated`,
      requestBody,
      {
        headers: { 'Cache-Control': 'no-cache' },
      }
    );
  }
}
